export const WASizePreviewViewabilityConfig = {
  minimumViewTime: 200,
  waitForInteraction: false,
  itemVisiblePercentThreshold: 95,
};
